<template>
  <div class="is-fullheight columns">
    <div class="column is-narrow">
      <Navigation></Navigation>
    </div>
    <div id="main-content" class="is-fullheight column">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Navigation from './components/Navigation'
export default {
  name: 'app',
  components: {
    Navigation
  }
}
</script>

<style lang="css">

  #main-content {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 10px;
    padding-left: 10px;
  }

  .is-fullheight {
    height: 100vh;
  }

  body, html {
    height: 100%;
    width: 100%;
  }

</style>
